import Vue from 'vue'
import FAQs from './App.vue'
import Buefy from 'buefy'

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

if(document.getElementById("faqsListApp")){
    new Vue({
        render: h=>h(FAQs, {
            props:{
                faqsCreateUrl:document.getElementById("faqsListApp").getAttribute("faqs-create-url"),
                faqsEditUrl:document.getElementById("faqsListApp").getAttribute("faqs-edit-url"),
                basicUrl: document.getElementById("faqsListApp").getAttribute("basic-info-url")
            }
        }
        )
    }).$mount("#faqsListApp")
}